<template>
  <b-navbar class="bg-dark" toggleable="md" type="dark">
    <b-container class="flex-md-row-reverse">
      <div class="navbar-toggler-wrapper">
        <b-navbar-toggle target="main_nav_collapse"></b-navbar-toggle>
      </div>

      <b-navbar-nav class="ml-auto animated zoomInDown">
        <b-nav-item href="#" v-on:click="logout" class="bg-secondary">
          <span class="text-light"> Sign Out</span>
        </b-nav-item>
        <!--<b-nav-item-dropdown class="user user-menu" right>-->
          <!-- Using button-content slot -->
        <!--  <template slot="button-content">-->
        <!--    <img class="user-image" src="http://i.pravatar.cc/160" alt="User Image" />-->
        <!--    <span class="hidden-xs">{{ fixedUsername() }}</span>-->
        <!--  </template>-->
        <!--  <b-dropdown-item href="#">-->
        <!--    <span class="pl-2">-->
        <!--      <font-awesome-icon icon="users-cog" />-->
        <!--      Account Setting-->
        <!--    </span>-->
        <!--  </b-dropdown-item>-->
        <!--  <b-dropdown-item href="#" v-on:click="logout">-->
        <!--    <span class="pl-2">-->
        <!--      <font-awesome-icon icon="sign-out-alt" />-->
        <!--      Sign Out-->
        <!--    </span>-->
        <!--  </b-dropdown-item>-->
        <!--</b-nav-item-dropdown>-->
      </b-navbar-nav>

      <b-collapse class="mr-auto" id="main_nav_collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/" router-link-active="active" exact>Home</b-nav-item>
          <b-nav-item to="/conversions" router-link-active="active">Conversions</b-nav-item>
          <b-nav-item to="/statistics" router-link-active="active">Statistics</b-nav-item>
          <b-nav-item to="/tracker" router-link-active="active">Tracker</b-nav-item>
          <!-- <b-nav-item to="/tracker2" router-link-active="active">Tracker2</b-nav-item> -->
          <b-nav-item to="/accounts" router-link-active="active" v-show="user.role && user.role.slug == 'owner'">Manage Accounts</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<style lang="scss">
  @import "~bootstrap/scss/mixins";

  .navbar {
    padding: 0;

    .nav-link {
      padding: 1rem;
    }
  }

  .navbar-nav .nav-item {
    &:hover {
      background: $nav-item-hover-bg;
    }

    &:active {
      background: $nav-item-active-bg;
    }

    &.active {
      background: $nav-item-active-bg
    }

    .nav-link.active {
      background: $nav-item-active-bg
    }
  }

  // force
  @include media-breakpoint-up(md) {
    .navbar-expand-md .navbar-nav .nav-link {
      padding: 1rem;
    }
  }

  @include media-breakpoint-up(xs) {
    .navbar-nav .dropdown-menu {
      position: absolute;
    }
  }

  @include media-breakpoint-down(sm) {
    .navbar-toggler-wrapper {
      padding: 1rem;
      margin-left: 1rem;

      .navbar-toggler {
        margin: -1rem;
      }
    }

    // sementara

    .navbar-toggler-wrapper {
      padding-top: .9rem;
      padding-bottom: .8rem;

      .navbar-toggler {
        margin: -1rem;
      }
    }

    .navbar .nav-link {
      padding-top: .5rem;
      padding-bottom: .5rem;
    }
  }

  .navbar-nav .user-menu {
    .user-image {
      float: left;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 10px;
      margin-top: -8px;
      margin-bottom: -8px;
    }

    .dropdown-menu {
      margin: 0;
      border: 0;
      min-width: 0;
      width: 100%;
      border-radius: 0 0 0.25rem 0.25rem;
      box-shadow: 0px 3px 3px 0px rgba(0,0,0,0.15);

      .dropdown-item {
        padding: 0.25rem 1rem;

        &:hover {
          background: #dee2e6;
        }

        &:active {
          color: #000000;
        }
      }
    }

    &:after {
      content: "\A0";
      display: block;
      border-top: 0.05rem solid rgba(52, 58, 64, 0.15);
      position: absolute;
      line-height: 0;
      width: 100%;
      bottom: 0;
      right: 0;
      left: 0;
    }

    .nav-link {
      max-width: 15rem;
      min-width: 11rem;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  .navbar-expand-md .navbar-nav .user-menu {
    .nav-link {
      padding-right: 1rem;
      padding-left: 1rem;
    }
  }

  .navbar-dark .navbar-nav .nav-item {
    &.user-menu.dropdown.show {
      background: #fff;

      .nav-link {
        color: #16181b;
      }
    }
  }
</style>

<script>
  export default {
    computed: {
      user() {
        return this.$store.state.authentication.user;
      }
    },
    methods: {
      fixedUsername() {
        const { username } = this.user;
        if (username) {
          return username.charAt( 0 ).toUpperCase() + username.slice( 1 );
        }

        return username;
      },
      logout() {
        this.$store.dispatch('authentication/logout').then( () => {
          this.$router.push('/login');

          if (typeof this.$socket !== 'undefined') {
            this.$socket.disconnect();
          }
        } );
      }
    }
  };
</script>